import { IgAccount, IgMedia } from '@core/models/ApiFields/ig-entities';
import { ColCateg, Sorting, TableInit } from '@features/social-analysis/models/ITable';
import { getDefaultColsObj } from '@features/social-analysis/utils/table-utils';
import { COMPONENTS_ENUM } from './page';

const columns: ColCateg[] = [
    {
        display: 'social',
        values: [
            {
                display: 'Posted on',
                value: IgMedia.getPrefixed('publishDate'),
                fixed: true,
                defaultCol: true,
                fixWidth: 140,
            },
            {
                display: 'Account',
                value: IgAccount.getPrefixed('image'),
                unsortable: true,
                fixed: true,
                defaultCol: true,
            },
            {
                display: 'Post',
                value: IgMedia.getPrefixed('resources'),
                unsortable: true,
                fixed: true,
                defaultCol: true,
            },

            {
                display: 'Avg Watch Time',
                value: IgMedia.getPrefixed('avgWatchTime'),
            },
            {
                display: 'Caption',
                value: IgMedia.getPrefixed('caption'),
                defaultCol: true,
            },
            {
                display: 'Comments',
                value: IgMedia.getPrefixed('comments'),
                defaultCol: true,
            },
            {
                display: 'Comments Sentiment',
                value: IgMedia.getPrefixed('commentsPositivity'),
                defaultCol: true,
            },
            {
                display: 'Content Type',
                value: IgMedia.getPrefixed('contentType'),
            },
            {
                display: 'Engagement Rate',
                value: IgMedia.getPrefixed('engagementRate'),
                defaultCol: true,
            },
            {
                display: 'Impressions',
                value: IgMedia.getPrefixed('impressions'),
            },
            {
                display: 'Interactions',
                value: IgMedia.getPrefixed('interactions'),
            },
            {
                display: 'Likes',
                value: IgMedia.getPrefixed('likes'),
                defaultCol: true,
            },
            {
                display: 'Media Type',
                value: IgMedia.getPrefixed('mediaType'),
                defaultCol: true,
            },
            {
                display: 'Swipe Back',
                value: IgMedia.getPrefixed('navigationSwipeBack'),
            },
            {
                display: 'Tap Back',
                value: IgMedia.getPrefixed('navigationTapBack'),
            },
            {
                display: 'Tap Exit',
                value: IgMedia.getPrefixed('navigationTapExit'),
            },
            {
                display: 'Tap Forward',
                value: IgMedia.getPrefixed('navigationTapForward'),
            },
            {
                display: 'Negative Comments',
                value: IgMedia.getPrefixed('negativeComments'),
            },
            {
                display: 'Positive Comments',
                value: IgMedia.getPrefixed('positiveComments'),
            },
            {
                display: 'Profile Activity',
                value: IgMedia.getPrefixed('profileActivity'),
            },
            {
                display: 'Profile Activity Bio',
                value: IgMedia.getPrefixed('profileActivityBio'),
            },
            {
                display: 'Profile Activity Call',
                value: IgMedia.getPrefixed('profileActivityCall'),
            },
            {
                display: 'Profile Activity Direction',
                value: IgMedia.getPrefixed('profileActivityDirection'),
            },
            {
                display: 'Profile Activity Email',
                value: IgMedia.getPrefixed('profileActivityEmail'),
            },
            {
                display: 'Profile Activity Other',
                value: IgMedia.getPrefixed('profileActivityOther'),
            },
            {
                display: 'Profile Activity Text',
                value: IgMedia.getPrefixed('profileActivityText'),
            },
            {
                display: 'Profile Views',
                value: IgMedia.getPrefixed('profileViews'),
            },
            {
                display: 'View Total Time',
                value: IgMedia.getPrefixed('viewTotalTime'),
            },
        ],
    },
];

const initColumns: Record<string, true> = getDefaultColsObj(columns);

export const postsInit: TableInit = {
    component: COMPONENTS_ENUM.POSTS,
    columns: columns,
    selectedCols: initColumns,
    hiddenSort: [{ prop: IgMedia.getPrefixed('publishDate'), dir: 'desc' }],
};
